import { c as _c } from "react/compiler-runtime";
import { InlineText as BaseInlineText, type InlineTextProps } from '@/components/block-primitives';
import { contextInlineMarkup } from '../inline-markup/context-inline-markup';
const InlineText = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <BaseInlineText {...props} registry={contextInlineMarkup} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default InlineText;